import './Loading.css'
import SyncLoader from 'react-spinners/SyncLoader';
import { useEffect, useState } from 'react';
const Loading = ({ isLoading }) => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        // console.log(isLoading);
        if (isLoading === false)
            document.body.style.pointerEvents = 'auto';
        else {
            document.body.style.pointerEvents = 'none';
        }
        setLoading(isLoading);
    }, [isLoading])
    return (
        <>
            <div className={isLoading == false ? "d-none" : ""} style={{ top: '25%', left: '50%', position: 'absolute', width: '500px', height: '250px', textAlign: 'center', zIndex: '9999', transform: 'translateX(-50%)' }}>
                <div style={{ transform: 'translateY(50%)' }}>
                    <SyncLoader
                        loading={loading}
                        color='#36d7b7'
                    />
                </div>
            </div>
        </>
    )
};
export default Loading;